var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFontStrikethrough(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99973 8C8.5967 8 9.18271 8.12825 9.69654 8.37135C9.92866 8.48117 10.1422 8.61261 10.3331 8.7623C10.5648 8.94398 10.7631 9.15254 10.9208 9.38199C11.2083 9.80049 11.3502 10.2731 11.3314 10.7504C11.3127 11.2278 11.134 11.6923 10.8142 12.0955C10.4943 12.4988 10.0449 12.8259 9.51303 13.0427C8.98114 13.2595 8.38622 13.3581 7.79043 13.3281C7.19465 13.2981 6.61986 13.1406 6.12612 12.8722C5.63238 12.6038 5.23782 12.2342 4.98364 11.8021",
    stroke: "#616874",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 8H13.3334",
    stroke: "#8796AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0162 4.19776C10.762 3.76564 10.3674 3.39606 9.87369 3.12762C9.37996 2.85919 8.80517 2.70175 8.20938 2.67177C7.6136 2.64178 7.01868 2.74034 6.48678 2.95715C5.95488 3.17397 5.50552 3.50107 5.18566 3.9043C4.86579 4.30753 4.68714 4.77207 4.66839 5.24941C4.6629 5.38926 4.67119 5.52871 4.69289 5.6665",
    stroke: "#616874",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontStrikethrough);
export default __webpack_public_path__ + "static/media/Font_Strikethrough.4dc9dc830f45ee09296fbe3fceb86f69.svg";
export { ForwardRef as ReactComponent };